import React from "react";
import { Route } from "react-router";
import { Switch } from "react-router-dom";

// Routes
import AllPeople from "./all-people";
import SinglePerson from "./single-person";

export default function () {
  return (
    <div>
      <Switch>
        <Route
          exact
          path="/administration/personnel"
          component={() => <AllPeople />}
        />
        <Route
          exact
          path="/administration/personnel/:id"
          component={() => <SinglePerson />}
        />
      </Switch>
    </div>
  );
}
